import { addMonths, format, isSameMonth, subMonths } from 'date-fns'
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

import { Button } from '@/components/ui'

export const MonthPicker = ({
  month,
  onChange,
}: {
  month: Date
  onChange: (month: Date) => void
}) => {
  const isCurrentMonth = isSameMonth(month, new Date())

  return (
    <div className="flex items-center gap-1">
      <Button
        isIcon
        theme="ghost"
        size="xs"
        aria-label="Previous month"
        onClick={() => onChange(subMonths(month, 1))}
      >
        <ChevronLeftIcon className="size-4" />
      </Button>
      <span className="min-w-32 text-center text-sm font-medium tabular-nums">
        {format(month, 'MMMM yyyy')}
      </span>
      <Button
        isIcon
        theme="ghost"
        size="xs"
        aria-label="Next month"
        disabled={isCurrentMonth}
        onClick={() => onChange(addMonths(month, 1))}
      >
        <ChevronRightIcon className="size-4" />
      </Button>
    </div>
  )
}
